<template lang="html">
  <div>
    <v-row>
      <v-col cols="12">
        <v-text-field
          v-model="search"
          placeholder="Enter search entry"
          append-icon="search"
          label="Search the table"
          hide-no-data
          hide-selected
          clearable 
        />
        <v-data-table
          :headers="headers"
          :items="promises"
          :loading="loading"
          :search="search"
          :custom-sort="customSort"
          :sort-by.sync="sortBy"
        >
          <template
            v-slot:item.conditions="{ item }"
          >
            <div>
              {{ item.conditions.substring(0,155) }} 
              <span v-if="item.conditions.length >155">...</span>
            </div>
          </template>

          <template v-slot:item.status="{ item }">
            <div>
              <span
                class="px-2 pl-0 font-weight-bold"
                :class="{ 
                  'text-success': item.is_approved, 
                  'text-danger': item.is_cancelled || item.is_rejected,
                  'text-info': !item.is_rejected && !item.is_approved && !item.is_cancelled,
                }"
              >
                {{ item.status }}
              </span>
            </div>
          </template>

          <template v-slot:item.created_at="{ item }">
            <div>
              <span class="font-weight-bold px-2 pl-0">
                {{ $moment(item.created_at).format('YYYY-MM-DD') }}
              </span>
            </div>
          </template>

          <template v-slot:item.due_date="{ item }">
            <div>
              <span class="font-weight-bold px-2 pl-0">
                {{ $moment(item.due_date).format('YYYY-MM-DD') }}
              </span>
            </div>
          </template>

          <template v-slot:item.stateNames="{ item }">
            <div>
              <span class="px-3 pl-0 font-weight-bold">
                {{ item.stateNames }}
              </span>
            </div>
          </template>

          <template v-slot:item.action="{ item }">
            <div>
              <employee-promises-dialog-update
                v-if="!item.is_approved && !item.is_cancelled && !item.is_rejected"
                :promise="item"
                @updated="emitUpdated()"
              />

              <employee-promises-dialog-update
                v-if="item.is_approved || item.is_cancelled || item.is_rejected"
                :promise="item"
                :view-only="true"
              />
            </div>
          </template>
        </v-data-table>
      </v-col>
    </v-row>
  </div>
</template>

<script>
  export default {
    components: {
      EmployeePromisesDialogUpdate: () => import('@/components/employee/promises/DialogUpdate'),
    },
    props: {
      approvedPromises: {
        type: Boolean,
        default: false,
      },         
    },
    data () {
      return {
        sortBy: 'status',
        promises: [],
        headers: [
          {
            text: 'Related Person',
            align: 'left',
            value: 'employee.user.name',
          },
          {
            text: 'Condition',
            value: 'conditions',
            align: 'left',
            width: '35%',
            sortable: false,
          },
          {
            text: 'Status',
            value: 'status',
            align: 'center',
          },
          {
            text: 'Created Date',
            value: 'created_at',
            align: 'center',
          },
          {
            text: 'Due',
            value: 'due_date',
            align: 'center',
          },
          {
            text: 'Actions',
            value: 'action',
            align: 'center',
            sortable: false,
          },
        ],
        loading: false,
        search: null,
      }  
    },
    created () {
      this.loadData()
    },
    methods: {
      emitUpdated () {
        this.$emit('updated')
      },
      loadData () {
        this.loading = true
        this.$api.promises().listOwned(this.approvedPromises 
          ? '?filter[approved]=true' 
          : '?filter[not_approved]=true')
          .then((res) => {
            this.promises = res.data

            this.promises.forEach((promise) => {
              if (promise.is_cancelled === true) {
                promise.status = 'Cancelled'
              } else if (promise.is_approved === true) {
                promise.status = 'Approved'
              } else if (promise.is_rejected === true) {
                promise.status = 'Rejected'
              } else {
                promise.status = 'Pending'
              }
            })
            this.loading = false
          })
      },
      customSort (items, index, isDesc) {
        items.sort((a, b) => {
          if (index[0] === 'status') {
            if (!isDesc[0]) {
              if (a.status === 'Pending' && b.status !== 'Pending') {
                return 1
              } else if (a.status !== 'Pending' && b.status === 'Pending') {
                return -1
              } else if (a.status === b.status) {
                return a.employee.user.name < b.employee.user.name ? -1 : 1
              }
            } else {
              if (a.status === 'Pending' && b.status !== 'Pending') {
                return -1
              } else if (a.status !== 'Pending' && b.status === 'Pending') {
                return 1
              } else if (a.status && b.status) {                
                return a.employee.user.name < b.employee.user.name ? -1 : 1
              }
            }
          } else if (index[0] === 'employee.user.name') {
            if (!isDesc[0]) {
              return a.employee.user.name < b.employee.user.name ? -1 : 1
            } else {
              return b.employee.user.name < a.employee.user.name ? -1 : 1
            }
          } else if (index[0] === 'created_at' || index[0] === 'due_date') {
            if (!isDesc[0]) {
              return this.$moment(a[index[0]]) < this.$moment(b[index[0]]) ? -1 : 1
            } else {
              return this.$moment(a[index[0]]) < this.$moment(b[index[0]]) ? 1 : -1
            }
          }
        })
        return items
      },
    },    
  }
</script>

<style lang='css' scoped>
</style>
